{
    "facilities": "Facilities",
    "machines": "Machines",
    "tickets": "Tickets"
}